import { render, staticRenderFns } from "./FeatureCardDocument.vue?vue&type=template&id=45ee9e57&"
import script from "./FeatureCardDocument.vue?vue&type=script&lang=js&"
export * from "./FeatureCardDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports